import React, { FC } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

export interface IWithRouterProps {
  navigate?: ReturnType<typeof useNavigate>
  location?: ReturnType<typeof useLocation>
}

export const withRouter = <P extends object>(Component: React.ComponentType<P>) => {
  const Wrapper: FC<P> = (props) => {
    const navigate = useNavigate()
    const location = useLocation()

    return <Component location={location} navigate={navigate} {...props} />
  }

  return Wrapper
}
